import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: 186,
    maxHeight: 186,
    padding: 0,
    [theme.breakpoints.down("xs")]: {
      display: "none"
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    paddingBottom: 0
  },
  content: {},
  title: {
    fontSize: 14,
    marginTop: -8,
    lineHeight: "14px",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: "#1a1a1a"
  },
  facilitySelect: {
    padding: 8,
    marginTop: -8,
    marginRight: -12,
    "& > .MuiButton-label": {
      fontSize: 14,
      lineHeight: "14px",
      "& > .MuiSvgIcon-root": {
        fontSize: 20
      }
    }
  },
  weather: {
    padding: "0 24px",
    marginTop: 12,
    [theme.breakpoints.down("sm")]: {
      padding: "0 16px"
    },
    "&.MuiList-root": {
      gap: 20,
      [theme.breakpoints.down("sm")]: {
        gap: 11
      }
    },
    "& .MuiListItem-root": {
      paddingTop: 0,
      paddingBottom: 0,
      "& .MuiTypography-root": {
        fontSize: 12,
        lineHeight: "12px",
        marginBottom: 8,
        whiteSpace: "nowrap"
      }
    },
    "&__temperature-container": {
      marginBottom: 16
    }
  }
}));
